import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "flip-card-front" }
const _hoisted_3 = { class: "flip-card-back" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: 'flip-transition-' + `${_ctx.id}`,
    class: "flip-card",
    style: _normalizeStyle(_ctx.size)
  }, [
    _createElementVNode("div", {
      class: "flip-card-inner",
      style: _normalizeStyle(_ctx.cssVars)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "front", {}, () => [
          _cache[0] || (_cache[0] = _createTextVNode(" Front "))
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "back", {}, () => [
          _cache[1] || (_cache[1] = _createTextVNode(" Back "))
        ])
      ])
    ], 4),
    _cache[2] || (_cache[2] = _createElementVNode("cite", { style: {"display":"none"} }, [
      _createTextVNode("Code is from "),
      _createElementVNode("a", { href: "w3schools.com/howto/howto_css_flip_card.asp" }, "w3schools.com/howto/howto_css_flip_card.asp")
    ], -1))
  ], 12, _hoisted_1))
}